import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BackImg from "../../images/backBtnBlack.svg";
import BackImgWhite from "../../images/backBtn.svg";

function BackButton(props) {
  const navigate = useNavigate();
  const{whiteTheme, link} = props
  return (
    <button className={whiteTheme ?  "w-10 h-10 flex justify-center items-center bg-gray-200 hover:bg-gray-300 rounded-md" :""} onClick={() => link ? navigate(link) : navigate(-1)}>
    <img className="back-image"  src={whiteTheme ? BackImg :BackImgWhite} alt="" />
    </button>
  );
}

export default BackButton;
